import {
  ModalFooter as CModalFooter,
  ModalFooterProps as CModalFooterProps,
  Divider,
  DividerProps,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

const propTypes = {
  spaceBetween: PropTypes.bool,
};

const defaultProps = {
  spaceBetween: false,
};

interface ModalFooterProps extends CModalFooterProps {
  spaceBetween: boolean;
  dividerProps: DividerProps;
}

const ModalFooter = ({
  spaceBetween,
  dividerProps,
  ...props
}: ModalFooterProps) => {
  return (
    <>
      <Divider marginTop={3} marginBottom={3} width="auto" {...dividerProps} />
      <CModalFooter
        paddingY={5}
        paddingX={8}
        justifyContent={spaceBetween ? 'space-between' : 'flex-end'}
        alignItems="center"
        flex="1 0"
        {...props}
      />
    </>
  );
};

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

export default ModalFooter;
